import React from 'react';
import PropTypes from 'prop-types';
import * as Filestack from 'filestack-js';
import LogRocket from '@helpers/logRocket';
import './styles/filestack_uploader';

// Requires inclusion of app/views/shared/_js_globals.erb
const filestackOptions = { security: BFG.filestack.signature_object, cname: BFG.filestack.cname };
const filestack = Filestack.init(BFG.filestack.API_KEY, filestackOptions);

export default class FilestackUploader extends React.Component {
  constructor(props) {
    super(props);
    this.picker = this.initializePicker('dropzone');
    this.overlayPicker = this.initializePicker('overlay');
  }

  componentDidMount() {
    if (this.props.type === 'area') {
      this.picker.open();
    }
  }

  componentWillUnmount() {
    this.picker.close();
    // this.overlayPicker.close(); Should not be a problem and logs error in console;
  }

  // If you would like to override any options, pass in using this.props.options
  defaultOptions = () => ({
    onUploadDone: this.props.onSuccess,
    onFileUploadFailed: this.handleError,
    disableThumbnails: true,
    maxFiles: 3000,
    fromSources: ['local_file_system', 'googledrive', 'dropbox', 'box', 'url', 'onedriveforbusiness'],
    globalDropZone: false,
    uploadConfig: {
      // default Filestack timeout for FII (intelligent ingestion) is only 1 minute
      timeout: 180000,
      intelligent: 'fallback'
    },
    storeTo: {
      location: 's3'
    }
  })

  storageOptions = () => {
    // if (BFG.context.useGCS) {
    //   return {
    //     storeTo: {
    //       location: "gcs"
    //     }
    //   };
    // }
    if (BFG.context.storageRegion !== BFG.context.defaultStorageRegion) {
      return {
        storeTo: {
          location: 's3',
          container: `bf-filestack-prod-${BFG.context.storageRegion}`,
          region: BFG.context.storageRegion,
          path: '/'
        }
      };
    }
    return {};
  }

  dropzoneOptions = () => ({
    container: this.props.dropzoneContainerId || 'filestack-dropzone',
    displayMode: 'dropPane',
    dropPane: {
      overlay: false,
      disableClick: true,
      onClick: this.openOverlayPicker.bind(this),
      customText: this.props.text || t('Drag file(s) here or click to browse')
    }
  })

  openOverlayPicker = () => {
    this.overlayPicker.open();
  }

  initializePicker(type) {
    const settings = (type.toLowerCase() === 'dropzone') ? this.dropzoneOptions() : {};
    const options = Object.assign(this.defaultOptions(), settings, this.storageOptions(), this.props.options);
    return filestack.picker(options);
  }

  handleError(file, error) {
    if (error && error.message.indexOf('cancel') === -1) {
      LogRocket.captureMessage('Error Uploading File to Filestack', {
        tags: { file, error },
        extra: { file, error }
      });
    }
  }

  renderUploadArea() {
    return (
      <div
        id="filestack-dropzone"
        className="filestack-upload-area"
      />
    );
  }

  render() {
    const { dropzoneContainerId } = this.props;
    const buttonStyle = (dropzoneContainerId && dropzoneContainerId.includes('checkin'))
      ? 'primary' : 'secondary';

    switch (this.props.type) {
      case 'button':
        return (
          <div className="filestack-uploader-component">
            <button
              className={`filestack-upload-button button ${buttonStyle}`}
              type="button"
              onClick={this.openOverlayPicker}
            >
              {this.props.text || t('Browse Files')}
            </button>
          </div>
        );
      case 'link':
        return (
          <div className="filestack-uploader-component">
            <a className="filestack-upload-link" onClick={this.openOverlayPicker}>
              {this.props.text || t('Add Files')}
            </a>
          </div>
        );
      default:
        if (this.props.dropzoneContainerId) { return ''; }
        return (
          <div className="filestack-uploader-component">
            { this.renderUploadArea() }
          </div>
        );
    }
  }
}

FilestackUploader.propTypes = {
  type: PropTypes.oneOf(['button', 'link', 'area']),
  text: PropTypes.string,
  options: PropTypes.shape({ maxFiles: PropTypes.number }),
  onSuccess: PropTypes.func,
  dropzoneContainerId: PropTypes.string,
};

FilestackUploader.defaultProps = {
  type: 'button',
  text: t('Drag file(s) here or click to browse'),
  options: {},
  onSuccess: () => {},
  dropzoneContainerId: null,
};
